import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { HttpService } from "./../../services/http.service";
import { ToolsService } from "./../../services/tools.service";
import { ActionnaireDialogComponent } from "./actionnaire-dialog";
import { ToastrService } from "./../../components/_toastr/toastr.service";
import { Actionnaire } from "../../interfaces/Actionnaire";

@Injectable({
  providedIn: "root",
})
export class ActionnaireDialogService {
  constructor(
    private _dialog: MatDialog,
    private _http: HttpService,
    private _tools: ToolsService,
    private _toastr: ToastrService
  ) {}

  openDialog(actionnaire_ID: number, callBack: Function = () => {}): void {
    const dialogRef = this._dialog.open(ActionnaireDialogComponent, {
      width: "1000px",
      data: actionnaire_ID,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && callBack) {
        callBack();
      }
    });
  }

  get(actionnaire_ID: number, callBack: Function): void {
    this._http.GET(
      "/api/actionnaire/" + actionnaire_ID,
      null,
      (result) => {
        if (result.isOk) {
          callBack(result.obj);
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  post(actionnaire: Actionnaire, callBack: Function): void {
    this._http.POST(
      "/api/actionnaire",
      actionnaire,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Actionnaire enregistré avec succès",
            type: "success",
          });
          // Retourner l'objet mis à jour avec le nouvel ID si c'est une création
          if (result.obj && result.obj.session_ID) {
            callBack(result.obj);
          } else {
            callBack(actionnaire);
          }
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  delete(actionnaire_ID: number, callBack: Function): void {
    this._http.DELETE(
      "/api/actionnaire/" + actionnaire_ID,
      null,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Actionnaire supprimé avec succès",
            type: "success",
          });
          callBack();
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }
}
